import {
  Button,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import {useGetRolesQuery} from 'api';
import RoleDeleteIconButton from './RoleDeleteIconButton';
import RoleEditIconButton from './RoleEditIconButton';
import CreateRoleModal from './CreateRoleModal';

const ROLE_TABLE_COLUMNS_SIZE = 4;

export function RolesTable() {
  const {data, isError, isSuccess, isLoading} = useGetRolesQuery();

  const [isCreateRoleModalOpen, setIsCreateRoleModalOpen] = React.useState(false);

  return (
    <>
      <CreateRoleModal
        open={isCreateRoleModalOpen}
        onClose={() => {
          setIsCreateRoleModalOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={ROLE_TABLE_COLUMNS_SIZE - 1}>Role Groups</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsCreateRoleModalOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="right">Group</TableCell>
              <TableCell align="right">Role</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="right">{row.group}</TableCell>
                  <TableCell align="right">{row.name}</TableCell>
                  <TableCell align="right">
                    <RoleEditIconButton role={row} />
                    <RoleDeleteIconButton roleId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={ROLE_TABLE_COLUMNS_SIZE}>No role found</TableCell>
              </TableRow>
            )}
            {!isLoading && isError && (
              <TableRow>
                <TableCell colSpan={ROLE_TABLE_COLUMNS_SIZE}>
                  <Typography color="error">Failed to fetch roles.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {[...Array(ROLE_TABLE_COLUMNS_SIZE)].map(() => (
                  <TableCell>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
